import "./app.scss";
import AppRouter from "./router/AppRouter";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { useMsalAuthentication } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { AppProvider } from "./context/AppProvider";

function App() {
  // Create a client
  const queryClient = new QueryClient();

  useMsalAuthentication(InteractionType.Redirect);

  return (
    <div className="App bg-bgApp">
      <QueryClientProvider client={queryClient}>
        <AppProvider>
          <AppRouter />
        </AppProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </div>
  );
}

export default App;
